"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./styles");

var _reactIntl = require("react-intl");

var _intlFormat = require("../../lib/intl-format");

var _translations = _interopRequireDefault(require("./translations"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var HelpMenu;

var _default = (0, _intlFormat.withTranslations)(_translations.default, HelpMenu = function () {
  var HelpMenu =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(HelpMenu, _React$Component);

    function HelpMenu() {
      _classCallCheck(this, HelpMenu);

      return _possibleConstructorReturn(this, _getPrototypeOf(HelpMenu).apply(this, arguments));
    }

    _createClass(HelpMenu, [{
      key: "render",
      value: function render() {
        return _react.default.createElement("div", {
          className: "HelpMenu"
        }, _react.default.createElement("section", null, _react.default.createElement("a", {
          href: "/help",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.help_center",
          defaultMessage: "Help Center"
        }))), _react.default.createElement("section", null, _react.default.createElement("a", {
          href: "/help/find_tickets",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.cant_find_tickets",
          defaultMessage: "Where are my tickets?"
        })), _react.default.createElement("a", {
          href: "/help/contact_organizer",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.contact_organizer",
          defaultMessage: "Contact the event organizer"
        })), _react.default.createElement("a", {
          href: "/help/get_refund",
          onClick: this.props.onNavigate
        }, _react.default.createElement(_reactIntl.FormattedMessage, {
          id: "library.navbar.can_refund",
          defaultMessage: "Can I get a refund?"
        }))));
      }
    }]);

    return HelpMenu;
  }(_react.default.Component);

  ;
  HelpMenu.propTypes = {
    user: _propTypes.default.object,
    onNavigate: _propTypes.default.func
  };
  return HelpMenu;
}.call(void 0));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@uniiverse/library/components/navbar/help-menu.js
// module id = 1484
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16